/**
 * Created by lihanying on 2017/6/29.
 */
export const GETADVERTLIST = 'GETADVERTLIST'
export const GETADVERTSETTING = 'GETADVERTSETTING'




// WEBPACK FOOTER //
// ./src/containers/AdvertManage/constants.js